import { useEffect } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet-async";
import CircularProgress from "@material-ui/core/CircularProgress";
import { MDBCol, MDBRow, MDBCard, MDBCardBody, MDBContainer } from "mdbreact";

import { getOffer } from "Store/actions/OfferActions";
import locale from "locale";
import Pricelist from "Components/Pages/Destination/Pricelist";
import OfferAmenities from "Components/Pages/Offer/OfferAmenities";
import OfferCollapse from "Components/Pages/Offer/OfferCollapse";
import OfferImages from "Components/Pages/Offer/OfferImages";
import OfferPriceTable from "Components/Pages/Offer/OfferPriceTable";
import Breadcrumb from "Components/Breadcrumb/Breadcrumb";

const Offer = ({ name, offer, getOffer, loading }) => {
  useEffect(() => {
    getOffer(name);
  }, [name, getOffer]);

  const isOfferLoaded = () => Object.keys(offer).length > 0;

  const hasAnyAmenities =
    offer.wiFi ||
    offer.bus ||
    offer.dvoriste ||
    offer.tv ||
    offer.klima ||
    offer.parking ||
    offer.kuhinja;

  if (loading || !isOfferLoaded())
    return (
      <div className="moz-l-progress--full-screen">
        <CircularProgress />
      </div>
    );

  return (
    <main className="moz-p-offer">
      <Helmet>
        <title>
          {offer
            ? offer.name + " " + locale.HELMET.BASIC_PAGE_TITLE
            : locale.HELMET.BASIC_PAGE_TITLE}
        </title>
      </Helmet>
      <div className="moz-p-offer__hero-img" />
      <MDBContainer className="moz-p-offer__container">
        <Breadcrumb destination={offer} name={name} />
        <MDBCard className="px-3 pb-3">
          <MDBCardBody>
            <div className="moz-p-offer__header">
              <h1 className="moz-p-offer__header-title">{name}</h1>
              <h2 className="moz-p-offer__single-price">{offer.cena}</h2>
            </div>
            <hr />
            <MDBRow className="mt-5 mb-2 mb-md-5">
              <MDBCol size="12" lg={hasAnyAmenities ? "9" : "12"}>
                <OfferImages images={offer.images} />
              </MDBCol>
              <MDBCol
                size="12"
                lg={hasAnyAmenities ? "3" : "0"}
                className="mb-4 mb-md-1 d-flex"
                style={{ alignItems: "center", justifyContent: "center" }}
              >
                <OfferAmenities offer={offer} />
              </MDBCol>
            </MDBRow>
            <MDBRow className="mb-5">
              <MDBCol size="12" lg="6" className="pb-5 pb-lg-2">
                <h3 className="heading-tertiary">{locale.OFFER.DESCRIPTION}</h3>

                <div
                  dangerouslySetInnerHTML={{
                    __html: offer.description
                  }}
                  className="paragraph"
                />
              </MDBCol>
              {offer.program && offer.program.length > 0 && (
                <MDBCol size="12" lg="6">
                  <h3 className="heading-tertiary">
                    {locale.OFFER.TRAVEL_PROGRAM}
                  </h3>
                  <OfferCollapse data={offer.program} />
                </MDBCol>
              )}
            </MDBRow>
            {offer.dates.length > 0 && (
              <OfferPriceTable
                dates={offer.dates}
                reductionTables={offer.tabelaUm}
                legend={offer.legenda}
                firstTableHeader={offer.tableHeader}
              />
            )}
            {offer && offer.ispodTabele && (
              <div
                style={{ fontSize: "1.6rem" }}
                dangerouslySetInnerHTML={{
                  __html: offer.ispodTabele
                }}
              />
            )}

            <MDBRow className="my-5">
              {offer.lat.length > 0 && offer.lng.length > 0 && (
                <MDBCol size="12" lg="6" className="mt-3">
                  <h3 className="heading-tertiary">{locale.OFFER.LOCATION}</h3>
                  <div
                    className=" rounded z-depth-1-half map-container"
                    style={{ height: "400px" }}
                  >
                    <iframe
                      src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyDjjbuBceicwkceicGQQ7lqSnd_ebfKrBg&q=${offer.lat},${offer.lng}&zoom=18&maptype=satellite`}
                      title={offer && offer.name}
                      width="100%"
                      height="100%"
                      frameBorder="0"
                      style={{ border: 0 }}
                    />
                  </div>
                </MDBCol>
              )}
              {offer.tabs && offer.tabs.length > 0 && (
                <MDBCol size="12" lg="6" className="mt-5">
                  <OfferCollapse data={offer.tabs} />
                </MDBCol>
              )}
              {offer.pricelistInPdf && (
                <MDBCol size="12" lg="6" className="mt-3">
                  <Pricelist downloadUrl={offer.pricelistInPdf} />
                </MDBCol>
              )}
            </MDBRow>
          </MDBCardBody>
        </MDBCard>
      </MDBContainer>
    </main>
  );
};

const mapStateToProps = (state) => ({
  offer: state.offers.currentOffer,
  loading: state.offers.loading
});

export default connect(mapStateToProps, { getOffer })(Offer);
